import { useAuthStore } from '../../../store/authStore'
import presidio_logo from '../../../assets/presidio_logo.png'
import './DashboardHeader.css'

interface DashboardHeaderProps {
  onLogout?: () => void
}

const DashboardHeader = ({ onLogout }: DashboardHeaderProps) => {
  const { user, signOut } = useAuthStore()

  // Same logout logic as Header component
  const handleLogout = async () => {
    try {
      await signOut()
      // Call the optional onLogout prop if provided
      onLogout?.()
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <header className="dashboard-header px-8 py-4">
      <div className="flex items-center justify-between w-full">
        {/* Left side - Title and Administrator Portal */}
        <div className="flex items-center space-x-4">
          <div className="brand-stack">
          <img src={presidio_logo} alt="Client Converge Logo" className="h-6 w-auto" />
          <p className="data-trust-accelerator">Data Trust Accelerator</p>
          </div>
          <span className='line'></span>
          <div className="administrator-portal">
            <span className="text-5xl font-xl text-gray-900">Administrator Portal</span>
          </div>
        </div>

        {/* Right side - User info and logout */}
        <div className="flex items-center space-x-4">
          <div 
            className="flex items-center space-x-3 px-4 py-2 rounded-full transition-colors duration-200"
            style={{
              background: 'linear-gradient(180deg, #F0F4FF 0%, #F1F3F9 100%)',
              border: '1px solid #E5E7EB80'
            }}
          >
            <div className="h-5 w-5 rounded-full bg-blue-500 flex items-center justify-center">
              <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <div className="text-sm font-medium text-gray-900">
              {user?.firstName || user?.email?.split('@')[0] || 'User'}
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="logout-button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="logout-icon"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}

export default DashboardHeader
